import { EnvironmentModel } from './environment.model';

export const environment: EnvironmentModel = {
  production: true
};
